// extracted by mini-css-extract-plugin
module.exports = {"ContainerGrey":"NoDataBlock_ContainerGrey__SZeKC","ChildText":"NoDataBlock_ChildText__li8rQ"};